import { observer } from 'mobx-react-lite';

import { AlignT, TextParagraphT } from 'types/shared/core/Post';
import { styled } from '@mui/material';

import quoteBegin from 'assets/images/post/text_paragraph_quote_begin.png';
import quoteEnd from 'assets/images/post/text_paragraph_quote_end.png';
import { useEffect, useRef } from 'react';
import interfaceBridge from 'utils/interfaceBridge';

type PostContentTextPropsT = {
  paragraph: TextParagraphT;
};

function nav(url: string) {
  interfaceBridge.nav('', url, 'external');
}

// 모바일에서는 네이티브의 external nav를 사용하게 하기위해
// onClick을 override한다
function convertUrlsToLinks(text) {
  const urlRegex =
    /(\b(https?):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" class="dynamic-link">${url}</a>`;
  });
}

const StyledTextParagraph = styled('div')<{
  talign: AlignT; // props 형태가 소문자만 가능하네
  quotation: number; // boolean
}>`
  padding: 0px 16px;

  & > div.text-paragraph {
    outline: none;
    text-align: ${(props) => props.talign};
    padding-top: ${(props) => (props.quotation ? '60px' : '0px')};
    padding-bottom: ${(props) => (props.quotation ? '60px' : '0px')};
    background: ${(props) =>
      props.quotation
        ? `url(${quoteBegin}) center top no-repeat , url(${quoteEnd}) center bottom no-repeat `
        : 'none'};
    background-size: 40px 40px;
    word-break: break-all;
  }

  & > div.text-paragraph > a.dynamic-link {
    text-decoration: none; /* Removes underline */
    color: inherit; /* Example color - change as needed */
    &:hover {
      text-decoration: underline; /* Optional: underline on hover */
    }
  }
`;

const PostContentText = observer(({ paragraph }: PostContentTextPropsT) => {
  console.log('postContentText');

  const textParagraphRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      // Check if the clicked element is a link and has the 'dynamic-link' class
      if (target.tagName === 'A' && target.classList.contains('dynamic-link')) {
        event.preventDefault();
        nav((target as HTMLAnchorElement).href);
      }
    };

    // Add event listener to the ref element
    const currentRef = textParagraphRef.current;
    if (currentRef) {
      currentRef.addEventListener('click', handleClick);
    }

    // Cleanup function to remove the event listener
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('click', handleClick);
      }
    };
  }, []);

  const htmlWithLinks = convertUrlsToLinks(paragraph.html);

  return (
    <StyledTextParagraph
      talign={paragraph.align}
      quotation={paragraph.isQuotation ? 1 : 0}
    >
      <div
        ref={textParagraphRef}
        className="text-paragraph"
        dangerouslySetInnerHTML={{ __html: htmlWithLinks }}
      />
    </StyledTextParagraph>
  );
});

export default PostContentText;
